import React from 'react';

import AWS from '../assets/aws.png';
import CSS from '../assets/css.png';
import GitHub from '../assets/github.png';
import HTML from '../assets/html.png';
import JavaScript from '../assets/javascript.png';
import Mongo from '../assets/mongo.png';
import MySQL from '../assets/mysql.png';
import Node from '../assets/node.png';
import PHP from '../assets/php.png';
import ReactImg from '../assets/react.png';
import Tailwindcss from '../assets/tailwind.png';
import Terraform from '../assets/terraform.png';

const Skills = () => {
  return (
    <div name='skills' className='skills-pj w-full max-h-full bg-[#0a0a6a] text-gray-300'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full'>
          <div>
              <p className='text-4xl text-[#fff] font-bold inline border-b-4 border-[#9A1AF8] '>Skills</p>
              <p className='py-4 text-[#9A1AF8]'>{'//'} <span className='text-[#fff]'>Technologies</span> that I have worked with: </p>
          </div>

          <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8'>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={HTML} alt="HTML icon" />
                  <p className='my-4'>HTML</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={CSS} alt="HTML icon" />
                  <p className='my-4'>CSS</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={Tailwindcss} alt="HTML icon" />
                  <p className='my-4'>TAILWINDCSS</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={JavaScript} alt="HTML icon" />
                  <p className='my-4'>JAVASCRIPT</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-5 w-24 mx-auto' src={PHP} alt="HTML icon" />
                  <p className='my-6'>PHP</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={ReactImg} alt="HTML icon" />
                  <p className='my-4'>REACT</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={Node} alt="HTML icon" />
                  <p className='my-4'>NODE JS</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={MySQL} alt="HTML icon" />
                  <p className='my-4'>MySQL</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={Mongo} alt="HTML icon" />
                  <p className='my-4'>MONGO DB</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-24 mx-auto' src={AWS} alt="HTML icon" />
                  <p className='my-8'>AWS</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={Terraform} alt="HTML icon" />
                  <p className='my-4'>TERRAFORM</p>
              </div>
              <div className='shadow-md shadow-[#9A1AF8] border-t-2 border-[#9A1AF8] hover:scale-110 duration-500'>
                  <img className='p-3 w-20 mx-auto' src={GitHub} alt="HTML icon" />
                  <p className='my-4'>GITHUB</p>
              </div>
          </div>
      </div>
    </div>
  );
};

export default Skills;
